import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IOfferUniqueCode } from '@/shared/model/offer-unique-code.model';

const baseApiUrl = 'api/offer-unique-codes';
const baseSearchApiUrl = 'api/_search/offer-unique-codes?query=';

export default class OfferUniqueCodeService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IOfferUniqueCode> {
    return new Promise<IOfferUniqueCode>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IOfferUniqueCode): Promise<IOfferUniqueCode> {
    return new Promise<IOfferUniqueCode>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IOfferUniqueCode): Promise<IOfferUniqueCode> {
    return new Promise<IOfferUniqueCode>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
